import { useContext } from "react";
import TableHeadCustom from "src/components/table/head-custom/TableHeadCustom";
import useLocales from "src/hooks/useLocales";

import cols from "./Cols";
import Context from "./contextTable";

interface Props {
	count: number;
}

export default function TableHeaderPositions({ count }: Props) {
	const { order, orderBy, onSort } = useContext(Context);
	const { translate } = useLocales();

	const label = cols.map(({ label, ...attr }) => ({
		label: translate(label),
		...attr
	}));

	return (
		<TableHeadCustom
			headLabel={label}
			onSort={onSort}
			order={order}
			orderBy={orderBy}
			rowCount={count}
		/>
	);
}
